import { render } from "./friendlierCard.vue?vue&type=template&id=7a3ac97e&scoped=true"
import script from "./friendlierCard.vue?vue&type=script&lang=js"
export * from "./friendlierCard.vue?vue&type=script&lang=js"

import "./friendlierCard.vue?vue&type=style&index=0&id=7a3ac97e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3ac97e"]])

export default __exports__